export enum TermsAndPoliciesField {
  TosUrl = 'tos_url',
  PrivacyPolicy = 'privacy_policy',
  CookiePolicy = 'cookie_policy'
}
